export const jsonToHtml = (jsonText: string): string => jsonText
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/\{/g, '&#123;')
    .replace(/\}/g, '&#125;')
    .replace(/\[/g, '&#91;')
    .replace(/\]/g, '&#93;')
    .replace(/\r\n|\r|\n/g, '<br>');

export const selectFromDocument = (selector: string): HTMLElement => document.querySelector<HTMLElement>(selector) as HTMLElement;

export const hasText = (element: HTMLElement): boolean => {
    // Get the text content of the element
    const text = element.textContent || element.innerText;
    // Trim whitespace and check if there's any text left
    return text.trim().length > 0;
};

export const hasAttribute = (element: HTMLElement, attribute: string): boolean => {
    // Get the text content of the element
    const text = element.getAttribute(attribute);
    if (!text) {
        return false;
    }
    // Trim whitespace and check if there's any text left
    return text.trim().length > 0;
};
